import { ResultDir } from '@alilc/lowcode-types';

import { createResultDir } from '../../../../../utils/resultHelper';
import { runFileGenerator } from '../../../../../utils/templateHelper';

import file7 from './files/src/layouts/BasicLayout/index.less'
import file5 from './files/src/App.js';
import file4 from './files/src/craco.config.js';
import file3 from './files/src/README.md';
import file2 from './files/src/layouts/BasicLayout/index.jsx';
import file1 from './files/src/menu/menu.js';


export function generateStaticFiles(root = createResultDir('.')): ResultDir {
  runFileGenerator(root, file1);
  runFileGenerator(root, file2);
  runFileGenerator(root, file3);
  runFileGenerator(root, file4);
  runFileGenerator(root, file5);
  runFileGenerator(root, file7);
  return root;
}
